export var TabState;
(function (TabState) {
    TabState["UNCOMPLETED"] = "uncompleted";
    TabState["COMPLETED"] = "completed";
})(TabState || (TabState = {}));
